import React, { FC } from 'react';
import { RPCErrorDetails } from './rpc';
import { text } from './text';

export const Error: FC<{
    error: RPCErrorDetails;
}> = ({ error }) => (
    <section>
        <aside>
            <div className="c-error">
                <h1>{text.oops}</h1>
                <p>{error.message}</p>
                {error.data && (
                    <p>
                        <pre>{error.data}</pre>
                    </p>
                )}
                <p>
                    {text.errorHelp}
                    <br />
                    <a href={`mailto:${text.helpEmail}`}>{text.helpEmail}</a>
                </p>
            </div>
        </aside>
    </section>
);
